<template>
  <div class="layout hs-layout">
    <div class="hs-title">
      <h2>
        <!-- HS检验(材质)报告录入 -->
        {{$t("HSInspectManageMat.t63")}}
      </h2>
      <div class="btn">
        <Button @click="goList">
          <!-- 返回 -->
          {{$t("HSInspectManageMat.t64")}}
        </Button>
        <Button :loading="loading" type="primary" @click="beforeHandleSubmit()" v-if="hsFormObjs.WORKFLOW_STATUS === '起草'">
          <!-- 提交 -->
          {{$t("HSInspectManageMat.t34")}}
        </Button>
      </div>
    </div>
    <Form ref="hsForm" :model="hsFormObjs" :rules="hsFormRules" :label-width="0">
      <table class="hs-table">
        <tr>
          <td width="150" class="hs-table-field">
            <!-- 流程编号 -->
            {{$t("HSInspectManageMat.t1")}}
          </td>
          <td width="215">
            {{hsFormObjs.REPORT_NO}}
          </td>
          <!-- <td width="150" class="hs-table-field">
            供方编码
          </td>
          <td width="215">
            {{hsFormObjs.SUPPLIER_CODE}}
          </td> -->
          <td class="hs-table-field">
            <!-- 报告类型 -->
            {{$t("HSInspectManageMat.t11")}}
          </td>
          <td>
            {{hsFormObjs.REPORT_TYPE_TL}}
          </td>
          <td width="150" class="hs-table-field">
            <!-- 流程状态 -->
            {{$t("HSInspectManageMat.t16")}}
          </td>
          <td width="215">
            {{hsFormObjs.WORKFLOW_STATUS}}
          </td>
        </tr>
        <!-- <tr>
          <td class="hs-table-field">
            事业部
          </td>
          <td>
            {{hsFormObjs.DIV_ID}}
          </td>
          <td class="hs-table-field">
            供应商简称
          </td>
          <td>

          </td>
          <td class="hs-table-field">
            提出日期
          </td>
          <td>

          </td>
        </tr> -->
        <tr>
          <td class="hs-table-field">
            <!-- 物料大类 -->
            {{$t("HSInspectManageMat.t2")}}
          </td>
          <td>
            {{hsFormObjs.BIG_CLASS_NAME}}
          </td>
          <td class="hs-table-field">
            <!-- 物料中类 -->
            {{$t("HSInspectManageMat.t12")}}
          </td>
          <td>
            {{hsFormObjs.MID_CLASS_NAME}}
          </td>
          <td class="hs-table-field">
            <!-- 物料小类 -->
            {{$t("HSInspectManageMat.t17")}}
          </td>
          <td>
            {{hsFormObjs.SMALL_CLASS_NAME}}
          </td>
        </tr>
        <!-- <tr>
          <td class="hs-table-field">
            发起人
          </td>
          <td></td>
          <td class="hs-table-field">填写人</td>
          <td>
            {{hsFormObjs.USER_MODIFIED}}
          </td>
        </tr> -->
        <tr>
          <td class="hs-table-field">
            <span class="c1">*</span>
            <!-- 报告日期 -->
            {{$t("HSInspectManageMat.t3")}}
          </td>
          <td>
            <FormItem prop="REPORT_DATE_TL">
              <DatePicker type="date" :options="dataOption" v-model="hsFormObjs.REPORT_DATE_TL" style="width:100%" transfer  :disabled="readOnly"></DatePicker>
            </FormItem>
          </td>
          <!-- <td class="hs-table-field">
            <span class="c1">*</span>有效期（年）
          </td>
          <td>
            <FormItem prop="ExpirationDate">
              <DatePicker type="year" v-model="hsFormObjs.ExpirationDate" style="width:100%" transfer></DatePicker>
            </FormItem>
          </td> -->
          <td class="hs-table-field">
            <!-- 失效日期 -->
            {{$t("HSInspectManageMat.t13")}}
          </td>
          <td>
            <FormItem prop="ExpirationDate_TL">
              <DatePicker type="date" v-model="hsFormObjs.ExpirationDate_TL" style="width:100%" transfer  disabled></DatePicker>
            </FormItem>
          </td>
          <td class="hs-table-field"><span class="c1">*</span>
            <!-- 报告编号 -->
            {{$t("HSInspectManageMat.t18")}}
          </td>
          <td>
            <FormItem prop="REPORT_CODE">
              <Input v-model="hsFormObjs.REPORT_CODE" :disabled="readOnly" @input="beforeSubmit()"></Input>
            </FormItem>
          </td>
        </tr>
        <tr>
          <td class="hs-table-field">
            <!-- 材质 -->
            {{$t("HSInspectManageMat.t40")}}
          </td>
          <td>
            {{hsFormObjs.MATERIAL_NAME}}
          </td>
          <td class="hs-table-field">
            <!-- 事业部 -->
            {{$t("HSInspectManageMat.t41")}}
          </td>
          <td>
            {{hsFormObjs.DIV_NAME}}
          </td>
          <td class="hs-table-field">
            <!-- 管控类型 -->
            {{$t("HSInspectManageMat.t42")}}
          </td>
          <td>
            {{hsFormObjs.CONTROL_TYPE_TL}}
          </td>
        </tr>
        <tr>
          <td class="hs-table-field">
            <!-- <span class="c1" v-if="hsFormObjs.WORKFLOW_STATUS === '起草'">*</span>
            <span v-else></span>报告计划完成日期 -->
            <span class="c1"></span>
            <!-- 报告计划完成日期 -->
            {{$t("HSInspectManageMat.t4")}}
          </td>
          <td>
            <FormItem prop="SUPPLIER_SUBMIT_DATE_TL">
              <DatePicker type="date" v-model="hsFormObjs.SUPPLIER_SUBMIT_DATE_TL" style="width:100%" transfer  :disabled="true"></DatePicker>
            </FormItem>
          </td>
          <td class="hs-table-field">
            <!-- 有效期倒计时(天) -->
            {{$t("HSInspectManageMat.t14")}}
          </td>
          <td>
            <FormItem prop="EXPIRATIONDATE_REC">
              <Input v-model="hsFormObjs.EXPIRATIONDATE_REC" style="width:100%" :disabled="true"></Input>
            </FormItem>
          </td>
          <td class="hs-table-field">
            <!-- 报告提交日期 -->
            {{$t("HSInspectManageMat.t19")}}
          </td>
          <td>
            <FormItem prop="SUBMIT_DATE_TL">
              <DatePicker type="date" v-model="hsFormObjs.SUBMIT_DATE_TL" style="width:100%" transfer  :disabled="true"></DatePicker>
            </FormItem>
          </td>
        </tr>
        <tr>
          <td class="hs-table-field"><span class="c1">*</span>
            <!-- 检测机构 -->
            {{$t("HSInspectManageMat.t5")}}
          </td>
          <td>
            <FormItem prop="FEELER_MECHANISM">
              <Input v-model="hsFormObjs.FEELER_MECHANISM" :disabled="readOnly" @input="beforeSubmit()"></Input>
            </FormItem>
          </td>
          <td class="hs-table-field"><span class="c1">*</span>
            <!-- 报告结论 -->
            {{$t("HSInspectManageMat.t15")}}
          </td>
          <td>
            <FormItem prop="CHECKED_RESULT">
              <!-- <Input v-model="hsFormObjs.CHECKED_RESULT" :disabled="readOnly" @input="beforeSubmit()"></Input> -->
              <Select v-model="hsFormObjs.CHECKED_RESULT" :disabled="readOnly" v-if="hsFormObjs.WORKFLOW_STATUS === '起草'">
                <Option value="Accept" key="Accept">
                  <!-- 合格 -->
                  {{$t("HSInspectManageMat.t65")}}
                </Option>
                <Option value="ConditionAccept" key="ConditionAccept">
                  <!-- 条件合格 -->
                  {{$t("HSInspectManageMat.t66")}}
                </Option>
              </Select>
              <Input v-else v-model="hsFormObjs.CHECKED_RESULT" disabled></Input>
            </FormItem>
          </td>
          <td class="hs-table-field"><span class="c1">*</span>
            <!-- 报告测试项目数量 -->
            {{$t("HSInspectManageMat.t20")}}
          </td>
          <td>
            <FormItem prop="TEST_ITEM_COUNT">
              <Input v-model="hsFormObjs.TEST_ITEM_COUNT" :disabled="readOnly" @input="beforeSubmit()"></Input>
            </FormItem>
          </td>
        </tr>
        <tr v-if="hsFormObjs.WORKFLOW_STATUS === '起草'">
          <td class="hs-table-field">
            <!-- 驳回次数 -->
            {{$t("HSInspectManageMat.t30")}}
          </td>
          <td>
            <FormItem prop="REJECT_COUNT">
              <Input v-model="hsFormObjs.REJECT_COUNT" :disabled="true" class="input-color"></Input>
            </FormItem>
          </td>
          <td class="hs-table-field">
            <!-- 驳回原因 -->
            {{$t("HSInspectManageMat.t8")}}
          </td>
          <td colspan="5">
            <Input v-model="hsFormObjs.REASON" type="textarea" :disabled="true" class="input-color" />
          </td>
        </tr>
        <tr>
          <td class="hs-table-field">
            <!-- 特殊要求 -->
            {{$t("HSInspectManageMat.t6")}}
          </td>
          <td colspan="5">
            <Input v-model="hsFormObjs.SPECIAL_REQUIREMENTS" type="textarea" disabled />
          </td>
        </tr>
        <tr>
          <td class="hs-table-field"><span class="c1">*</span>
            <!-- 备注 -->
            {{$t("HSInspectManageMat.t7")}}
          </td>
          <td colspan="5">
            <FormItem  prop="REMARK">
              <Input v-model="hsFormObjs.REMARK" type="textarea" :disabled="readOnly" @input="beforeSubmit()"/>
            </FormItem>
          </td>
        </tr>
        <tr v-if="hsFormObjs.WORKFLOW_STATUS !== '起草'">
          <td class="hs-table-field">
            <!-- 驳回原因 -->
            {{$t("HSInspectManageMat.t8")}}
          </td>
          <td colspan="5">
            <Input v-model="hsFormObjs.REASON" type="textarea" :disabled="readOnly" class="input-color" :maxlength="666" />
          </td>
        </tr>
        <tr>
            <td class="hs-table-field">
              <!-- HS发布人 -->
              {{$t("HSInspectManageMat.t9")}}
            </td>
            <td>
              <FormItem prop="PUBLISH_NAME">
                <Input v-model="hsFormObjs.PUBLISH_NAME" :disabled="true"></Input>
              </FormItem>
            </td>
            <td colspan="4"></td>
        </tr>
      </table>
      <div class="hs-space"></div>
      <Collapse accordion v-model="coolapseVal" class="collapse-layout validfile">
          <Panel name="1">
              <!-- 发起附件 -->
              {{$t("HSInspectManageMat.t35")}}
              <div slot="content">
                <Upload  v-if="hsFormObjs.WORKFLOW_STATUS === '起草'" 
                        :action="uploadFileUrl" 
                        :format="['xls', 'xlsx', 'doc', 'docx', 'jpeg', 'jpg', 'png', 'gif', 'pdf', 'txt', 'xml', 'rar', 'zip', '7z']"
                        ref="appendFileRef" 
                        :on-success="successUpload" :on-error="failUpload" 
                        :on-form-change="fileUpload" 
                        :before-upload="beforeUpload"
                        :on-remove="removeFile" 
                        :disabled="hsFormObjs.ID === ''">
                    <Button icon="ios-cloud-upload-outline">
                      <!-- 选择上传文件 -->
                      {{$t("HSInspectManageMat.t36")}}
                    </Button>
                </Upload>
                <div class="validfile-p">
                  <p v-for="item in this.hsFormObjs.REPORT_FILE.split(',')" :key="item" style="margin-bottom:5px;">
                    <a href="javascript:;" style="display:inline-block;margin-right:20px;">{{item.split(':')[0]}}</a>
                    <Button size="small" type="primary"  @click="downloadFile(item.split(':')[1])">
                      <!-- 下载 -->
                      {{$t("HSInspectManageMat.t37")}}
                    </Button>
                    <Button size="small" type="error" @click="deleteFile(item.split(':')[1])">
                      <!-- 删除 -->
                      {{$t("HSInspectManageMat.t38")}}
                    </Button>
                  </p>
                  <!-- <a v-for="item in this.hsFormObjs.REPORT_FILE.split(',')" :key="item" href="javascript:;" style="display:inline-block;margin-right:20px;" @click="downloadFile(item.split(':')[1])">{{item.split(':')[0]}}</a> -->
                </div>
              </div>
          </Panel>
      </Collapse>
      <div class="hs-space"></div>
      <Collapse accordion v-model="coolapseVal2" class="collapse-layout">
          <Panel name="1">
              <!-- 审批记录 -->
              {{$t("HSInspectManageMat.t39")}}
              <div slot="content">
                {{hsFormObjs.AUDITOR}} - {{hsFormObjs.WORKFLOW_STATUS}}
                <!-- <p style="color:blue;cursor:pointer" @click="goQms">{{qmsUrl}}</p> -->
                <p><a @click="goQms(qmsUrl2)">{{qmsUrl2}}</a></p>
              </div>
          </Panel>
      </Collapse>
    </Form>
  </div>
</template>
<script>
import axios from 'axios';
export default {
  data () {
    return {
      fileName: '',
      // vendorCode: '',
      appendFile: null,
      uploadFileUrl: '/qms2gsc/file/upload?',
      loading: false,
      readOnly: false,
      hsFormObjs: {
        // MATERIAL_NAME: '',    // 材质
        // DIV_NAME: '',         // 事业部
        // CONTROL_TYPE_TL: '',  // 管控类型
        WORKFLOW_STATUS: '',
        ID: '',
        REPORT_FILE: '',
        TEST_ITEM_COUNT: '',
        SPECIAL_REQUIREMENTS: '',
        PUBLISH_NAME: ''
      },
      coolapseVal: '1',
      coolapseVal2: '1',
      hsFormRules: {
        REPORT_DATE_TL: [
          { required: true, type: 'date', message:  this.$t("HSInspectManageMat.t67"), trigger: 'change' } // '报告日期不能为空',
        ],
        REPORT_CODE: [
           { required: true, message: this.$t("HSInspectManageMat.t68"), trigger: 'blur' } // '报告编号不能为空'
        ],
        FEELER_MECHANISM: [
          { required: true, message: this.$t("HSInspectManageMat.t69"), trigger: 'blur' } // '检测机构不能为空'
        ],
        CHECKED_RESULT: [
          { required: true, message: this.$t("HSInspectManageMat.t70"), trigger: 'blur' } // '报告结论不能为空'
        ],
        TEST_ITEM_COUNT: [
          { required: true, message: this.$t("HSInspectManageMat.t71"), trigger: 'blur' } // '报告测试项目数量不能为空'
        ],
        REMARK: [
          { required: true, message: this.$t("HSInspectManageMat.t72"), trigger: 'blur' } // '备注不能为空'
        ]
      },
      DIV_ID: '',
      REPORT_NO: '',
      WORKFLOW_STATUS: '',
      ID: '',
      dataOption: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now();
        },
      },
      mdmCode: '',
    };
  },
  computed: {
    qmsUrl() {
      return `http://${window.environment.isPro ? 'qms.midea.com' : 'qmsuat2.midea.com'}/iqc/HsReportRejectLog/ViewRejectLog?FromExternal=1&report_no=${this.hsFormObjs.REPORT_NO}`;
    },
    qmsUrl2() {
      return `http://${window.environment.isPro ? 'qms.midea.com' : 'qmsuat2.midea.com'}/iqc/HsMaterialReportRejectLog/ViewRejectLog?FromExternal=1&report_no=${this.hsFormObjs.REPORT_NO}`;
    },
  },
  methods: {
    queryVendorAndMdm() {
      axios.post('/gscint/vendor/queryVendorAndMdm', {
        vendorCode: this.vendorCode,
      }).then((res) => {
        this.mdmCode = res.data.data.datas.mdmCode;
        this.getHsDetail();
        // debugger
      });
    },
    goQms(url) {
      window.open(url);
    },
    catLenFun(texVal) {
      // 一个字符转化为三个字节
      const len = texVal.replace(/[^\x00-\xff]/g, '011').length;
      return len;
    },
    /* 数据校验 */
    hsValidate() {
      // let keyCode = event.keyCode;
      let obj = this.hsFormObjs;
      let msg = '';
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          let val = obj[key];
          if (key === 'REPORT_CODE' && val) { // 报告编号
            let texLength = this.catLenFun(val);
            if (texLength <= 80) {
                event.returnValue = true;
            } else {
                event.returnValue = false;
                msg += this.$t("HSInspectManageMat.t73") + `</br>`; // '【报告编号】超长，请缩短【报告编号】'
            }
          }
          if (key === 'FEELER_MECHANISM' && val) { // 检测机构
            let texLength = this.catLenFun(val);
            if (texLength <= 240) {
                event.returnValue = true;
            } else {
                event.returnValue = false;
                msg += this.$t("HSInspectManageMat.t74") + `</br>`; // '【检测机构】超长，请缩短【检测机构】'
            }
          }
          if (key === 'CHECKED_RESULT' && val) { // 报告结论
            let texLength = this.catLenFun(val);
            if (texLength <= 240) {
                event.returnValue = true;
            } else {
                event.returnValue = false;
                msg += this.$t("HSInspectManageMat.t75") + `</br>`; // '【报告结论】超长，请缩短【报告结论】'
            }
          }
          if (key === 'TEST_ITEM_COUNT' && val) { // 报告测试项目数量
            let reg = /^\d+$/;
            let texVal = val;
            // console.log('~~~texVal报告测试项目数量:', texVal, typeof rexVal);
            if (!reg.test(texVal)) {
              event.returnValue = false;
              msg += this.$t("HSInspectManageMat.t76") + `</br>`; // '【报告测试项目数量】限定为数字'
            } else {
              event.returnValue = true;
            }
          }
          if (key === 'REMARK' && val) { // 备注
            let texLength = this.catLenFun(val);
            if (texLength <= 2000) {
                event.returnValue = true;
            } else {
                event.returnValue = false;
                msg += this.$t("HSInspectManageMat.t77"); // '【备注】超长，请缩短【备注】'
            }
          }
        }
      }
      return msg;
    },
    beforeSubmit() {
      let msg = this.hsValidate();
      if (msg) {
        this.$Modal.error({
          title: this.$t("HSInspectManageMat.t48"), // this.$t('common.warn'),
          content: msg
        });
      }
    },
    submitTips () {
      this.$Modal.success({
          title: this.$t("HSInspectManageMat.t48"), // '提示',
          content: this.$t("HSInspectManageMat.t43"), // '提交成功',
          closable: false,
          onOk: () => {
            this.$router.push({
              name: 'HSInspectManageMaterial'
            });
          }
      });
    },
    beforeUpload (file) {
      this.fileName = file.name;
    },
    beforeHandleSubmit() {
      this.$refs.hsForm.validate((valid) => {
        if (valid) {
          this.beforeSubmit(); /* 手工输入长度限制 */
          let muploadlistLi = document.querySelector('.validfile .m-upload-list li');
          let painner = document.querySelector('.validfile .validfile-p a');
          if (!muploadlistLi && !painner.innerHTML) {
            this.$Modal.error({
              title: this.$t("HSInspectManageMat.t48"), // this.$t('common.warn'),
              content: this.$t("HSInspectManageMat.t36"), // '请上传附件'
            });
            return false;
          }
          if (this.hsFormObjs.REJECT_MAX_COUNT) {
            if (Number(this.hsFormObjs.REJECT_MAX_COUNT) >= Number(this.hsFormObjs.REJECT_COUNT)) {
              let n = Number(this.hsFormObjs.REJECT_MAX_COUNT) - Number(this.hsFormObjs.REJECT_COUNT);
              this.$Modal.confirm({
                content: this.$t("HSInspectManageMat.t78").replace('#a', n).replace('#b', this.hsFormObjs.REJECT_MAX_COUNT), // `您还有${n}次提交机会，当驳回次数 > ${this.hsFormObjs.REJECT_MAX_COUNT}，待流程审批通过后才允许继续录入出货报告，将影响供货，有问题请联系对应品质`,
                onOk: () => {
                  setTimeout(() => {
                    this.handleSubmit();
                  }, 300);
                },
                onCancel: () => {}
              });
            } else {
              this.handleSubmit();
            }
          } else {
            this.handleSubmit();
          }
        }
      });
    },
    handleSubmit () {
      this.loading = true;
      axios.post('/gscint/hsCheck/UpdateReport', {
          ID: this.hsFormObjs.ID,
          FEELER_MECHANISM: this.hsFormObjs.FEELER_MECHANISM,
          CHECKED_RESULT: this.hsFormObjs.CHECKED_RESULT, // ??
          REMARK: this.hsFormObjs.REMARK,
          REPORT_DATE: this.hsFormObjs.REPORT_DATE_TL,
          REPORT_CODE: this.hsFormObjs.REPORT_CODE,
          TEST_ITEM_COUNT: Number(this.hsFormObjs.TEST_ITEM_COUNT),
          USER_MODIFIED: JSON.parse(localStorage.getItem('supplierInfo')).userName,
          REASON: this.hsFormObjs.REASON,
          HsType: 'Material',
          DIV_ID: this.DIV_ID,
      })
      .then((res) => {
        this.loading = false;
        let datas = res.data.data.datas;
        console.log('datas', datas);
        let resp = JSON.parse(datas.substring(1).substring(0, datas.length - 3));
        if (resp.IsSucess) {
          if (!resp.SubResultData) {
            this.submitTips();
          } else {
            this.$Modal.error({
                title: this.$t("HSInspectManageMat.t48"), // this.$t('common.warn'),
                content: resp.SubResultData,
                onOk: () => {
                  setTimeout(() => {
                    this.submitTips();
                  }, 500);
                }
            });
          }
        } else {
          this.$Modal.error({
              title: this.$t("HSInspectManageMat.t48"), // this.$t('common.warn'),
              content: resp.ErrorMessage
          });
        }
      })
      .catch((err) => {
        console.log('err:', err);
        this.loading = false;
        this.$Modal.error({
            title: this.$t("HSInspectManageMat.t48"), // this.$t('common.warn'),
            content: this.$t("HSInspectManageMat.t49"),
        });
      });
    },
    fileUpload () {
      // debugger;
    },
    getHsDetail (isReloadFile) {
      let params = {
        ID: this.ID,
        DIV_ID: this.DIV_ID,
        // REPORT_NO: this.REPORT_NO,
        SUPPLIER_CODES: this.mdmCode
        // WORKFLOW_STATUS: this.WORKFLOW_STATUS
      };
      axios.post('/gscint/hsCheck/GetMaterialReportList', params)
      .then((res) => {
        let resultData = res.data.data.datas.MainResultData.DATA;
        if (!isReloadFile) {
          try {
            let tempObj = {};
            tempObj = {
              ...resultData[0],
              REPORT_DATE_TL: resultData[0].WORKFLOW_STATUS === '起草' ? '' : (resultData[0].REPORT_DATE_TL ? new Date(resultData[0].REPORT_DATE_TL.replace(new RegExp('-', 'g'), '/')) : ''),
              CHECKED_RESULT: resultData[0].WORKFLOW_STATUS === '起草' ? '' : resultData[0].CHECKED_RESULT_TL,
              ExpirationDate_TL: resultData[0].ExpirationDate_TL ? new Date(resultData[0].ExpirationDate_TL.replace(new RegExp('-', 'g'), '/')) : ''
            };
            for (let key in tempObj) {
              if (tempObj.hasOwnProperty(key)) {
                let element = tempObj[key];
                this.$set(this.hsFormObjs, key, element);
              }
            }
            this.hsFormObjs.TEST_ITEM_COUNT = this.hsFormObjs.TEST_ITEM_COUNT ? this.hsFormObjs.TEST_ITEM_COUNT.toString() : '';
          } catch (err) {
            console.log(err);
          }
          if (this.hsFormObjs.WORKFLOW_STATUS !== '起草') {
            this.readOnly = true;
          }
        } else {
          this.$refs.appendFileRef.clearFiles();
          this.hsFormObjs.REPORT_FILE = resultData[0].REPORT_FILE;
        }
        let actionUrl;
        if (this.uploadFileUrl.indexOf('busid') > -1) {
          actionUrl = this.uploadFileUrl;
        } else {
          actionUrl = this.uploadFileUrl + 'busid=' + this.hsFormObjs.ID;
        }
        // this.$refs.appendFileRef.action = actionUrl;
        this.uploadFileUrl = actionUrl;
      });
    },
    goList() {
      this.$router.push({
        name: 'HSInspectManageMaterial'
      });
    },
    failUpload() {
      this.$Modal.error({
        title: this.$t("HSInspectManageMat.t48"), // this.$t('common.warn'),
        content: this.$t("HSInspectManageMat.t79") // '附件上传失败，请重新上传！'
      });
      this.$refs.appendFileRef.clearFiles();
    },
    successUpload(file) {
      let resp = JSON.parse(file.substring(1).substring(0, file.length - 3));
      if (!resp.IsSucess) {
        this.$Modal.error({
          content: resp.ErrorMessage
        });
        this.$refs.appendFileRef.clearFiles();
      }
      // try {
      //   this.appendFile = file;
      //   this.$refs.appendFileRef.post(this.appendFile);
      //   return false;
      // } catch (err) {
      //   console.log('err_successUpload:', err);
      // }
      // 上传附件日志记录
      axios.post('/gscapp/hsCheck/saveUploadFileInfo', {
        vendorCode: this.mdmCode, // this.vendorCode,
        fileId: this.ID,
        logs: this.fileName
      });
    },
    onFormatErrorUpload() {},
    onExceededSizeUpload() {},
    downloadFile(id) {
      window.open(`/qms2gsc/file/download?id=${id}`);
    },
    deleteFile(id) {
      this.$Modal.confirm({
        content: this.$t("HSInspectManageMat.t80"), // '确定要删除附件吗？',
        onOk: () => {
          axios.get(`/qms2gsc/file/delete?id=${id}`)
          .then(() => {
            this.getHsDetail(true);
          });
        }
      });
    },
    removeFile(file) {
      let id = JSON.parse(file.response.substring(1).substring(0, file.response.length - 3)).MainResultData;
      axios.get(`/qms2gsc/file/delete?id=${id}`);
    }
  },
  mounted() {
    console.log('this.$refs.appendFileRef', this.$refs.appendFileRef);
    this.DIV_ID = this.$route.query.DIV_ID;
    this.REPORT_NO = this.$route.query.REPORT_NO;
    this.WORKFLOW_STATUS = this.$route.query.WORKFLOW_STATUS;
    this.ID = this.$route.query.ID;
    this.queryVendorAndMdm();
  }
};
</script>
<style lang="less" scoped>
.layout {
  background: #FFF;
  padding-bottom: 10px; 
}
.hs-title {
  padding: 20px 10px;
  background: #F2F2F2;
  position: relative;
  margin-bottom: 10px;
  border: 1px solid #CCC;
  h2 {
    font-size: 14px;
    color: #999;
  }
  .btn {
    position: absolute;
    right: 20px;
    top: 15px;
  }
}
.hs-space {
  height: 10px;
}
.hs-table {
  width: 1100px;
  border-collapse: collapse;
  margin: 0 auto;
  td {
    height: 40px;
    border: 1px solid #CCC;
    padding: 10px;
  }
  .hs-table-field {
    background: #F2F2F2;
    text-align: center;
  }
  .c1 {
    color: red;
  }
}
.collapse-layout {
  width: 1100px;
  margin: 0 auto;
}
/deep/ .input-color {
  input, textarea{
    color: red;
  }
}
</style>
<style lang="less">
.hs-table {
  .m-form-item {
    margin-bottom: 0;
  }
}
</style>
